<template>
  <!-- 代码预览弹窗 
    @author 王汝鹏
    @version 2019-09-19
   -->
  <div class="code-preview">
    <editor height="500px"
            width="100%"
            :content="value"
            :options="{
              enableBasicAutocompletion: true,
              enableSnippets: true,
              enableLiveAutocompletion: true,
              tabSize:2
            }"
            :fontSize="14"
            :lang="'html'"
            :theme="'eclipse'">
    </editor>
  </div>
</template>

<script>
import Editor from "vue2x-ace-editor";
import ace from "brace";
import "brace/ext/language_tools";
import "brace/mode/html";
import "brace/snippets/html";
import "brace/theme/eclipse";


export default {
  name: 'MakeCodePreview',
  components: { Editor },
  props: {
    value: {
      type: String,
      default: "",
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Form/MakeCodePreview.vue